import { useState, useEffect } from 'react';
import { Aliment, categoriesAliments } from '@/mocks/aliments';
import { supabase } from '@/lib/supabase';

/** Convertit une ligne Supabase (snake_case BDD) en Aliment (camelCase front) */
const dbToAliment = (row: Record<string, unknown>): Aliment => ({
  id: row.id as number,
  nom: row.nom as string,
  categorie: row.categorie as Aliment['categorie'],
  image: row.image as string,
  description: row.description as string,
  glucidesPour100g: Number(row.glucides_pour_100g ?? 0),
  calories100g: Number(row.calories_100g ?? 0),
  fibres100g: Number(row.fibres_100g ?? 0),
  indexGlycemique: Number(row.index_glycemique ?? 0),
  proteines100g: row.proteines_100g ? Number(row.proteines_100g) : undefined,
  lipides100g: row.lipides_100g ? Number(row.lipides_100g) : undefined,
  sucres100g: row.sucres_100g ? Number(row.sucres_100g) : undefined,
  chargeGlycemique: row.charge_glycemique ? Number(row.charge_glycemique) : undefined,
  nutriscore: row.nutriscore as string | undefined,
  aliases: (row.aliases as string[] | null) ?? undefined,
  source: row.source as string | undefined,
  scoreConfiance: row.score_confiance ? Number(row.score_confiance) : undefined,
});

/**
 * Hook qui retourne les aliments depuis Supabase
 */
export function useAliments() {
  const [aliments, setAliments] = useState<Aliment[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAliments = async () => {
      setLoading(true);
      setError(null);
      try {
        const { data, error: supaError } = await supabase
          .from('aliments')
          .select('*')
          .order('nom');

        if (supaError) throw new Error(supaError.message);

        setAliments((data ?? []).map(dbToAliment));
      } catch (e) {
        setError(e instanceof Error ? e.message : 'Erreur de chargement');
      } finally {
        setLoading(false);
      }
    };

    fetchAliments();
  }, []);

  return { allAliments: aliments, loading, error };
}